/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Dialog, Paper, Avatar, Typography, Button, IconButton, CircularProgress, Accordion, AccordionSummary, AccordionDetails, AccordionActions, FormControlLabel, Checkbox, Tooltip,
Table, TableBody, TableHead, TableRow, TableCell, TableContainer, Popover } from '@material-ui/core'
import { Clear, AssignmentInd, ExpandMore, Beenhere, VerifiedUser, VerifiedUserOutlined, AssignmentTurnedIn, Layers, LayersClear, Bookmark, Delete, Warning } from '@material-ui/icons'
import { Skeleton, Pagination, ToggleButtonGroup, ToggleButton } from '@material-ui/lab'

import Action from '../../../fluid/Actions/ActionFactory'

const clone = require('rfdc')()

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class ReportEditor extends Component {
    state = {
        num_of_groups : null,
        num_of_pages : null,
        groups : null,
        cur_page : null,
        getting_groups : false,
        cur_group_id : null,
        saving : false,
        saving_error : false,
        error_message : null,
        changes_saved : true,
        action_required : false,
        status_required : false,
        close_alert : false,
        close_alert_anchorEl : null
    }

    componentDidMount () {
        let action_required = this.props.ic_data.world_view.configs.find(config => config.operation === 'Deduplicate').config_params.is_action_required
        let status_required = this.props.ic_data.world_view.configs.find(config => config.operation === 'Deduplicate').config_params.is_status_required
        this.setState({
            ...this.state, 
            getting_groups : true,
            action_required : action_required,
            status_required : status_required
        }, () => {
            let num_of_groups = this.props.metadata.num_groups
            let group_ids = this.props.metadata.group_ids.map(group => {
                return group.id
            })
            console.log("Group IDs: ", group_ids)
            console.log("Loose Groups : ", (num_of_groups % 10))
            let num_of_loose_groups = (num_of_groups % 10)
            let num_of_pages
            if (num_of_loose_groups > 0) {
                num_of_pages = ((num_of_groups - (num_of_groups % 10))/10) + 1
            } else {
                num_of_pages = ((num_of_groups)/10)
            }

            Action('http_request', {
                url : '/sainapse/duplicate_detection/report/group/get/records',
                method : 'post',
                data : {
                    group_ids : group_ids
                },
                params : {
                    ic_name : this.props.ic_name,
                    version : this.props.version
                }
            }).then(res => {
                this.setState({
                    ...this.state, 
                    num_of_groups : num_of_groups, 
                    num_of_pages : num_of_pages, 
                    groups : res.data.result.Result,
                    cur_page : 1,
                    cur_group_id : 1,
                    getting_groups : false
                }, () => console.log("Report State : ", this.state))
            })
        })        
    }

    renderGroupsSection = () => {
        return (
            <div style = {{width : '100vw', height : 'calc(100vh - 50px)'}}>
                <div style = {{width : '100%', height : '40px', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography style = {{fontSize : '15px', fontWeight : 500, marginLeft : '10px'}} variant = 'h6'>Groups</Typography>
                </div>
                <div style = {{width : '100%', height : 'calc(100vh - 140px)',backgroundColor : '#F0F0F0', overflow : 'scroll'}}>
                    {this.renderGroups()}
                </div>
                <div style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row-reverse', alignItems : 'center', borderTop : '1px solid rgba(0,0,0,0.12)'}}>
                    {this.renderPagination()}
                </div>
            </div>
        )
    }

    renderGroups = () => {
        if (this.state.getting_groups) {
            return (
                <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress clor = 'primary'/>
                </div>
            )
        } else {
            return (
                <div style = {{width : '100%', height : '100%', padding : '10px'}}>
                    {this.state.groups !== null ? this.renderPaginatedGroups() : null}
                </div>
            )
        }
    }

    getPaginatedGroups = () => {
        let group_start = ((this.state.cur_page - 1) * 10 ) + 1
        let group_end = (this.state.cur_page) * 10

        let paginated_groups = []

        this.state.groups.map(group => {
            if (group.group_id >= group_start && group.group_id <= group_end) {
                paginated_groups.push(group)
            }
        })

        return paginated_groups
    }

    renderPaginatedGroups = () => {
        let paginated_groups = this.getPaginatedGroups()
        console.log("Paginated Groups :", paginated_groups)
        let groups = paginated_groups.map(group => {
            return (
                <Accordion 
                    style = {{backgroundColor : '#FAFBFC'}} 
                    key = {group.group_id} 
                    expanded = {this.state.cur_group_id === group.group_id ? true : false} 
                    onChange = {() => this.setState({...this.state, cur_group_id : group.group_id})}
                >
                    <AccordionSummary
                        expandIcon = {<ExpandMore fontSize = 'small'/>}
                    >
                        <FormControlLabel
                            style = {{margin : 0, padding : 0}}
                            aria-label="Review Status"
                            onClick={(event) => {
                                this.toggleGroupReview(group.group_id)
                                event.stopPropagation()
                            }}
                            onFocus={(event) => event.stopPropagation()}
                            control={
                                <Checkbox 
                                    color = 'primary' 
                                    icon={<Tooltip title = "Complete Review"><VerifiedUserOutlined/></Tooltip>} 
                                    checkedIcon={<Tooltip title = "Reviewed"><VerifiedUser style = {{color : '#4caf50'}}/></Tooltip>}
                                    checked = {group.review === "False" ? false : true}
                                />}
                            label = {<Typography variant = 'subtitle2'>{"Group ID : " + group.group_id}</Typography>}
                        />
                    </AccordionSummary>
                    <AccordionDetails>
                        {this.renderRecords(group.group_id)}
                    </AccordionDetails>
                    <AccordionActions>
                        <Button color = 'primary' onClick = {() => this.completeAndProceed(group.group_id)}>Complete and Proceed</Button>
                    </AccordionActions>
                </Accordion>
            )
        })

        return groups
    }

    renderRecords = (group_id) => {
        let records = this.state.groups.find(group => group.group_id === group_id).records
        let columns = Object.keys(records[0].wv_field_list)

        return (
            <TableContainer component = {Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {columns.map(column => {
                                return(
                                    <TableCell>
                                        {column}
                                    </TableCell>
                                )
                            })}
                            {this.state.status_required && <TableCell>Status</TableCell>}
                            {this.state.action_required && <TableCell>Action</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            records.map((record, i) => {
                                return (
                                    <TableRow>
                                        {columns.map(column => {
                                            return (
                                                <TableCell>{record.wv_field_list[column]}</TableCell>
                                            )
                                        })}
                                        {this.state.status_required && <TableCell>{this.renderStatus(group_id, record, i)}</TableCell>}
                                        {this.state.action_required && <TableCell>{this.renderActions(group_id, record, i)}</TableCell>}
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    renderStatus = (group_id, record, index) => {
        return (
            <ToggleButtonGroup exclusive value = {record.status} size = 'small' onChange = {(event, value) => this.updateRecordStatus(group_id, index, value)}>
                <ToggleButton value = 'Primary'>
                    <Tooltip title = 'Primary'>
                        <AssignmentTurnedIn style = {{color : record.status === 'Primary' ? '#4caf50' : null}}/>
                    </Tooltip>
                </ToggleButton>
                <ToggleButton value = 'Genuine Duplicate'>
                    <Tooltip title = 'Genuine Duplicate'>
                        <Layers style = {{color : record.status === 'Genuine Duplicate' ? '#2296f3' : null}}/>
                    </Tooltip>
                </ToggleButton>
                <ToggleButton value = 'Incorrect Duplicate'>
                    <Tooltip title = "Incorrect Duplicate">
                        <LayersClear style = {{color : record.status === 'Incorrect Duplicate' ? '#dc004e' : null}}/>
                    </Tooltip>
                </ToggleButton>
            </ToggleButtonGroup>
        )
    }

    renderActions = (group_id, record, index) => {
        return (
            <ToggleButtonGroup exclusive value = {record.action} size = 'small' onChange = {(event , value) => this.updateRecordAction(group_id, index, value)}>
                <Tooltip title = 'Retain'>
                    <ToggleButton value = 'Retain'>
                        <Bookmark style = {{color : record.action === 'Retain' ? '#4caf50' : null}}/>
                    </ToggleButton>
                </Tooltip>
                <Tooltip title = 'Delete'>
                    <ToggleButton value = 'Delete'>
                        <Delete style = {{color : record.action === 'Delete' ? '#dc004e' : null}}/>
                    </ToggleButton>
                </Tooltip>
            </ToggleButtonGroup>
        )
    }

    updateRecordStatus = (group_id, index, value) => {
        if (value !== null) {
            console.log("Updating Record Status :", value)
            let new_groups = clone(this.state.groups)
            let group_index = new_groups.findIndex(group => group.group_id === group_id)
            new_groups[group_index].records[index].status = value
            new_groups[group_index].review = "True"
            this.setState({...this.state, groups : new_groups, changes_saved : false})
        }
    }

    updateRecordAction = (group_id, index, value) => {
        let new_groups = clone(this.state.groups)
        let group_index = new_groups.findIndex(group => group.group_id === group_id)
        new_groups[group_index].records[index].action = value
        new_groups[group_index].review = "True"
        this.setState({...this.state, groups : new_groups, changes_saved : false})
    }

    toggleGroupReview = (group_id) => {
        let new_groups = clone(this.state.groups)
        let group_index = new_groups.findIndex(group => group.group_id === group_id)

        let cur_review_state = new_groups[group_index].review

        if (cur_review_state === "False") {
            new_groups[group_index].review = "True"
        } else {
            new_groups[group_index].review = "False"
        }

        this.setState({...this.state, groups : new_groups, changes_saved : false})
    }

    completeAndProceed = (group_id) => {
        let new_groups = clone(this.state.groups)
        let group_index = new_groups.findIndex(group => group.group_id === group_id)

        let cur_review_state = new_groups[group_index].review
        new_groups[group_index].review = "True"
        let next_group = group_index === new_groups.length - 1 ? null : new_groups[group_index + 1].group_id
        this.setState({...this.state, groups : new_groups, cur_group_id : next_group, changes_saved : false})
    }

    pageChange = (event, value) => {
        this.setState({...this.state, cur_page : value})
    }

    renderPagination = () => {
        if (this.state.getting_groups) {
            return (
                <Skeleton width = '50%' height = {30}/>
            )
        } else {
            return (
                <Pagination count = {this.state.num_of_pages} page = {this.state.cur_page} siblingCount={5} boundaryCount={5} onChange = {this.pageChange}/>
            )
        }
    }

    saveAndClose = () => {
        let reviewed_groups = this.state.groups.filter(group => group.review === 'True')
        console.log('Reviewed Groups :', reviewed_groups)
        this.setState({...this.state, saving : true, saving_error : false, error_message : null }, () => {
            Action('http_request', {
                url : '/sainapse/duplicate_detection/report/group/records',
                method : 'post',
                data : {
                    data : reviewed_groups
                },
                params : {
                    ic_name : this.props.ic_name,
                    version : this.props.version 
                }
            }).then(res => {
                this.setState({...this.state, saving : false, saving_error : false, changes_saved : true})
            }).catch(err => {
                this.setState({...this.state, saving : false, saving_error : true, error_message : 'Error saving the report.'})
            })
        })
    }

    saveAndCloseEditor = () => {
        let reviewed_groups = this.state.groups.filter(group => group.review === 'True')
        console.log('Reviewed Groups :', reviewed_groups)
        this.setState({...this.state, saving : true, saving_error : false, error_message : null }, () => {
            Action('http_request', {
                url : '/sainapse/duplicate_detection/report/group/records',
                method : 'post',
                data : {
                    data : reviewed_groups
                },
                params : {
                    ic_name : this.props.ic_name,
                    version : this.props.version 
                }
            }).then(res => {
                this.setState({...this.state, saving : false, saving_error : false, changes_saved : true}, () => this.props.close_editor())
            }).catch(err => {
                this.setState({...this.state, saving : false, saving_error : true, error_message : 'Error saving the report.'})
            })
        })
    }

    completeReview = () => {
        Action('http_request', {
            url : '/sainapse/duplicate_detection/report/review/stop',
            method : 'post',
            data : {},
            params : {
                ic_name : this.props.ic_name,
                version : this.props.version
            }
        }).then (res => {
            this.props.close_editor()
        }).catch (err => {

        })
    }

    closeEditor = (event) => {
        if (this.state.changes_saved) {
            this.props.close_editor()
        } else {
            this.setState({...this.state, close_alert : true, close_alert_anchorEl : event.currentTarget})
        }
    }

    handleClose = () => {
        this.setState({...this.state, close_alert : false, close_alert_anchorEl : null })
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}> 
                <Dialog fullScreen open = {this.props.open}>
                    <Paper style = {{width : '100vw', height : '100vh', display : 'flex', flexDirection : 'column'}}>
                        <div style = {{width : '100%', height : '50px', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : "1px solid rgba(0,0,0,0.12)"}}>
                            <Avatar style = {{backgroundColor : "#2296f3", marginRight : '10px'}}>
                                <AssignmentInd style = {{color : '#FFFFFF'}}/>
                            </Avatar>
                            <Typography style = {{flexGrow : 1, fontSize : '15px', fontWeight : '500'}} variant = 'h6'>{"IC Name: " + this.props.ic_name + " - Version : " + this.props.version}</Typography>
                            <Typography variant = 'caption' color = 'secondary'>{this.state.error_message}</Typography>
                            <Button 
                                style = {{margin: '5px'}} 
                                variant = 'contained' 
                                color = 'primary'
                                disabled = {this.state.changes_saved ? true : false}
                                startIcon = {this.state.saving ? <CircularProgress size = {20} style = {{color : '#FFFFFF'}}/> : null}
                                onClick = {this.saveAndClose}
                            >Save</Button>
                            <Button 
                                style = {{margin: '5px'}} 
                                variant = 'contained' 
                                color = 'primary'
                                disabled = {this.state.changes_saved ? false : true}
                                onClick = {this.completeReview}
                            >Complete</Button>
                            <IconButton size = 'small'>
                                <Clear fontSize = 'small' onClick = {this.closeEditor}/>
                            </IconButton>
                        </div>
                        <div style = {{width : '100vw', height : 'calc(100vh - 50px)'}}>
                            {this.renderGroupsSection()}
                        </div>
                    </Paper>
                </Dialog>
                <Popover
                    id={'close_alert'}
                    open={this.state.close_alert}
                    anchorEl={this.state.close_alert_anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                >
                    <div style = {{width :'30vw', padding : '10px', display : 'flex', flexDirection : 'column', justifyContent : 'center', alignItems : 'center'}}>
                        <Warning style = {{color : '#cc3300', fontSize : '40px', margin : '10px'}}/>
                        <Typography style = {{width : '65%'}} align = 'center' color = 'textSecondary'>You have not saved your changes. Do you want to exit without saving?</Typography>
                        <div>
                            <Button
                                style = {{margin : '10px'}}
                                variant = 'outlined'
                                color = 'secondary'
                                size = 'small'
                                onClick = {() => this.setState({...this.state, close_alert : false, close_alert_anchorEl : null }, () => this.props.close_editor())}
                            >Exit Without Saving</Button>
                            <Button
                                style = {{margin : '10px'}}
                                variant = 'contained'
                                color = 'primary'
                                size = 'small'
                                onClick = {() => this.setState({...this.state, close_alert : false, close_alert_anchorEl : null }, () => this.saveAndCloseEditor())}
                            >{"Save & Exit"}</Button>
                        </div>
                    </div>
                </Popover>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(ReportEditor);